import { Component, OnInit } from '@angular/core';
import {FormatIntranetShareService} from '../../../../../../service/partage/prototype/FormatIntranetShareService';
import {ListeContactService} from '../../../../../../service/interne/contact/ListeContactService';
import {Suivi} from '../../../../../../model/suivi/Suivi';
import {ListeContact} from '../../../../../../model/liste/ListeContact';
import {ActivatedRoute} from '@angular/router';
import {DialogueShareService} from '../../../../../../service/partage/utilitaire/DialogueShareService';
import {NgxSpinnerService} from 'ngx-spinner';

@Component({
  selector: 'app-escal-liste-contact-fiche-suivis',
  templateUrl: './escal-liste-contact-fiche-suivis.component.html',
  styleUrls: ['./escal-liste-contact-fiche-suivis.component.scss'],
  providers: [ ListeContactService ]
})
export class EscalListeContactFicheSuivisComponent implements OnInit {
  private sub: any;
  listeContact: ListeContact;
  suivisAssocies: Array<Suivi>;
  suivis: Array<Suivi>;
  suivisPagination: Array<Suivi>;
  curentPage = 1;
  maxPage: number;
  total: number;
  fakeArray: Array<any>;
  page: number;
  periodeDeb: Date;
  periodeFin: Date;
  structureChoisi: string;
  critere: string;
  constructor(private listeContactService: ListeContactService, public formatIntranetShareService: FormatIntranetShareService,
              private route: ActivatedRoute, private dialogueShareService: DialogueShareService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.page = 1;
    this.structureChoisi = 'client';
    this.critere = '';
    this.suivisAssocies = [];
    this.spinner.show();
    this.sub = this.route.params.subscribe(async params => {
      await this.listeContactService.getListeContactDetails(params.id)
        .then(async (retour) => {
          this.listeContact = retour as ListeContact;
          await this.listeContactService.getAllSuivisListeContact(this.listeContact.id).then(suivis => {
            this.suivisAssocies = suivis as Array<Suivi>;
            this.total = this.suivisAssocies.length;
            this.getMaxPage(this.suivisAssocies.length);
            // on renvoie les 10 premiers
            this.curentPage = 1;
            this.getChangePage(this.curentPage);
            this.fakeArray = new Array(this.maxPage);
            this.spinner.hide();
          });
        });
    });
  }

  rechercheParPeriode() {
    if (this.periodeDeb !== undefined && this.periodeFin !== undefined) {
      this.listeContactService.getAllSuivisListeContactPeriode(this.listeContact.id, this.periodeDeb, this.periodeFin).then(suivis => {
        this.suivisAssocies = suivis as Array<Suivi>;
        this.total = this.suivisAssocies.length;
        this.getMaxPage(this.suivisAssocies.length);
        // on renvoie les 10 premiers
        this.curentPage = 1;
        this.getChangePage(this.curentPage);
        this.fakeArray = new Array(this.maxPage);
      });
    } else if (this.periodeDeb === undefined) {
      this.dialogueShareService.addDialogue('La date de début est obligatoire');
    } else if (this.periodeFin === undefined) {
      this.dialogueShareService.addDialogue('La date de fin est obligatoire');
    }
  }

  rechercheParCritere() {
    if (this.critere != '') {
      this.listeContactService.getAllSuivisListeContactCritere(this.listeContact.id, this.critere, this.structureChoisi).then(suivis => {
        this.suivisAssocies = suivis as Array<Suivi>;
        this.total = this.suivisAssocies.length;
        this.getMaxPage(this.suivisAssocies.length);
        // on renvoie les 10 premiers
        this.curentPage = 1;
        this.getChangePage(this.curentPage);
        this.fakeArray = new Array(this.maxPage);
      });
    } else {
      this.dialogueShareService.addDialogue('Le critère est obligatoire');
    }
  }

  getChangePage(page) {
    const that = this;
    this.suivisPagination = [];
    this.curentPage = page;
    let position = this.curentPage * 10 ; // 3 pages donc 30, on va donc commencer à 20
    let nbElement = 0;
    that.suivisAssocies.forEach(suivi => {
      if (nbElement === position - 10) {
        this.suivisPagination.push(suivi);
        if (position - 10 < this.curentPage * 10 - 1) {
          position +=  1;
        }
      }
      nbElement = nbElement + 1;
    });
  }

  getMaxPage(nbElement) {
    this.maxPage = Math.trunc(nbElement / 10);
    if (nbElement % 10 !== 0) {
      this.maxPage = this.maxPage + 1;
    }
  }

  changePage(page) {
    this.curentPage = page;
    this.ngOnInit();
  }

  pageMoins() {
    if (this.curentPage > 0) {
      this.curentPage = Number(this.curentPage) - 1;
      this.getChangePage(this.curentPage);
    }
  }

  pagePlus() {
    if (this.curentPage < this.maxPage) {
      this.curentPage = Number(this.curentPage) + 1;
      this.getChangePage(this.curentPage);
    }
  }

  accesPage() {
    this.getChangePage(this.curentPage);
  }

}
